var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArmArrowGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0999796 3.50166L4.55331 0.16166C5.0807 -0.233882 5.83331 0.142424 5.83331 0.80166V6.60166C5.83331 7.2609 5.0807 7.6372 4.55331 7.24166L0.0999797 3.90166C-0.0333537 3.80166 -0.0333537 3.60166 0.0999796 3.50166Z",
    fill: "#E3E8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArmArrowGray);
export default __webpack_public_path__ + "static/media/leftArmArrowGray.fb0b72e9546b48c194b6886bf1d60574.svg";
export { ForwardRef as ReactComponent };